const TriangleExclamation = () => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.00007 5.8334V8.50007M8.00007 10.3334V10.3267M6.29906 2.9173L2.05412 9.78147C1.23013 11.1139 2.18851 12.8334 3.75512 12.8334H12.245C13.8116 12.8334 14.77 11.1139 13.946 9.78146L9.70107 2.9173C8.91934 1.65322 7.0808 1.65322 6.29906 2.9173ZM8.16673 10.3334C8.16673 10.4254 8.09212 10.5001 8.00007 10.5001C7.90802 10.5001 7.8334 10.4254 7.8334 10.3334C7.8334 10.2414 7.90802 10.1667 8.00007 10.1667C8.09212 10.1667 8.16673 10.2414 8.16673 10.3334Z"
      stroke="#7A7A83"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
)

export default TriangleExclamation
